import { useState } from "react";
import { post } from "../networking/RequestService";
import { toast } from "react-toastify";
import { useExtensionContext } from "../modules/extension/ExtensionContext";
import { apiErrorText } from "app/popleads/networking/apiErrorText";

const useGorevEkle = (profileId) => {
    const [gorev, setGorev] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const { refetchTaskList } = useExtensionContext();

    const gorevEkle = async ({
        metin,
        zaman,
        profilId,
        guncelleProfilId,
        assignedToIds,
        activityId,
        type,
        important,
        customerHappiness,
        taskColour,
    }) => {
        setLoading(true);
        setError(null);
        try {
            const response = await post({
                fn: "gorevEkle",
                metin,
                zaman,
                profilId,
                guncelleProfilId,
                assignedToIds,
                activityId,
                type,
                important,
                customerHappiness,
                taskColour,
            });

            if (response?.data?.profile) {
                const profile = response.data.profile;
                profile.inhouseInquiries = profile.gorev
                    .filter((item) => item.activityType === "In-house Inquiry")
                    .map((item) => ({
                        label: item.activityName,
                        value: item.activityId,
                    }));
                setGorev(profile);
                toast.success("Task created successfully");
                //refetchProfile();
                refetchTaskList();
            }

            return response;
        } catch (err) {
            toast.error(apiErrorText(err));
            setError(err);
            setGorev(null);
            throw err;
        } finally {
            setLoading(false);
        }
    };

    return { gorev, loading, error, gorevEkle };
};

export default useGorevEkle;
